// extracted by mini-css-extract-plugin
export default {"videoBackground":"VideoBackground_videoBackground__8vckn"};